import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.css']
})
export class RadioButtonComponent {

  @Input() disabled: boolean;
  @Input() options: any[];
  @Input() name: string;
  @Input() model: any;
  @Output() modelChange = new EventEmitter<any>();

  constructor() { }

  change($event) {
    this.modelChange.emit(this.model);
  }

  checked(val): boolean {
    const checked = this.model == val;
    return checked;
  }

  opts() : any[] {
    let opts = [];
    if (this.options) {
      if ('string' == typeof this.options) {
        this.options = JSON.parse(this.options)
      }
      opts = this.options;
    }
    return opts;
  }
}
